/**
 * @file SettingsPage.tsx
 * @brief Super Admin → System Settings.
 *
 * @details
 * Single flush GridBlock (no inter-block gaps). Pricing / cost alerts →
 * Billing. AI providers → AiConfigurationCard as sibling grid rows.
 *
 * @author DES
 * @date 05-07-2026
 * @updated 09-09-2026 — Modules moved to Superadmin → Modules
 * @updated 15-10-2026 — the simple AI page first (AiSettingsSimple, DES:
 *   "bari confusing hai"); the full card is under "All settings (technical)"
 */

import {
  GridBand,
  GridBlock,
} from "@/features/analytics/components/GridBlock";
import { gridPageBleedClass } from "@/features/analytics/components/gridPageBleed";
import { AiConfigurationCard } from "./components/AiConfigurationCard";
import { AiSettingsSimple } from "./components/AiSettingsSimple";

export function SettingsPage() {
  return (
    <div className={gridPageBleedClass("pb-6")}>
      <GridBlock>
        <GridBand className="py-3">
          <h2 className="text-xl font-semibold tracking-tight">
            AI settings
          </h2>
          <p className="mt-1 max-w-xl text-sm text-muted-foreground">
            What runs each product, and what it costs us. Modules turn products
            on and off; prices and cost alerts are on the Billing page.
          </p>
        </GridBand>

        <GridBand className="px-0 py-0 md:px-0">
          <AiSettingsSimple advanced={<AiConfigurationCard />} />
        </GridBand>

      </GridBlock>
    </div>
  );
}
